export default "__VITE_PUBLIC_ASSET__2f97082d__"